<div
    class="retry-component radius-16 bc-primary-gray-50 liveness-closed-container w-100 bc-mono-white main-shadow"
    ngClass.desktop="pt-72 pb-76 pl-32 pr-32"
    ngClass.mobile="pt-40 pb-48 pl-16 pr-16 mt-40"
    fxLayout="column"
    fxLayoutAlign.desktop="center center"
    fxLayoutAlign.mobile="start center">
    <ui-kit-svg class="i-80" [name]="retryIconName"></ui-kit-svg>
    <div class="h2-semi-bold c-primary-gray-900 mt-24 text-center pre-wrap" ngClass.mobile="h3-semi-bold">
        {{ ('i18n_auth_livenessStateTitle#' + retryStatus) | translate }}
    </div>
    <div class="t3 mt-24 c-primary-gray-900 text-center pre-wrap">
        {{ ('i18n_auth_livenessStateSubtitle#' + retryStatus) | translate }}
    </div>
    <ui-kit-button [type]="buttonType"
                   [label]="('i18n_auth_livenessStateButton#' + retryStatus) | translate"
                   class="mt-40"
                   spinnerId="livenessStarted"
                   (clickListener)="retry.emit()">
    </ui-kit-button>
</div>
